<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2.5" />
    <path d="M4 7l8 5.5L20 7" />
  </svg>
</template>
